import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export function UserAvatar({ user, size = "h-9 w-9", className = "" }) {
  const initials = (user?.name || "?")
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <Avatar className={`${size} ${className}`}>
      {user?.avatarUrl ? <AvatarImage src={user.avatarUrl} alt={user?.name} /> : null}
      <AvatarFallback className="bg-primary/20 text-primary font-poppins font-semibold text-xs">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
